export default __webpack_public_path__ + "static/media/Pharo_Icon.243262a5.png";